import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'
import { LoadingIcon } from '@/components/icons/loading'

interface CrosschainPendingStateProps {
  message?: string
}

export const CrosschainPendingState = ({
  message = 'Your crosschain transaction is being processed...',
}: CrosschainPendingStateProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Note color="blue">
        <div className="flex items-center gap-2">
          <LoadingIcon size={16} className="animate-spin" />
          <span>{message}</span>
        </div>
      </Note>
      <Button type="button" size="sm" disabled className="gap-2">
        <LoadingIcon size={16} className="animate-spin" />
        Transaction pending
      </Button>
    </div>
  )
}
